<template>
  <v-card
          v-if="node"
          outlined class="dialog"
          :style="dialogStyle">
    <v-card-text class="px-2 pt-1 pb-0">
      <div class="d-flex justify-space-between">
        <i class=" align-self-center">{{node.name}}</i>
        <v-btn
                text icon
                class="pa-0"
                @click="closeDialog"
                title="close">
          <v-icon x-small>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-text>
    <v-card-text class="pa-1">
      <div v-if="node.is_roadmap">
        <v-btn text class="pa-1 ma-0 v-btn"
               @click="toRoadmapPlanBuilder(node.slug)">
          <small>Build your plan</small>
          <v-icon small right>mdi-rocket</v-icon>
        </v-btn>
      </div>
      <div v-else-if="node.is_concept">
        <v-btn text class="pa-1 ma-0 v-btn"
               @click="toConceptViewer(node.slug)">
          <small>Learn more about</small>
          <v-icon small right>mdi-rocket</v-icon>
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>


<script>
  export default {
    name: "NodeDialog",
    props: {
      node: Object,
      closeDialog: Function
    },
    computed: {
      dialogStyle() {
        let {node} = this;
        let style = {};
        if (node) {
          let {x, y, _size} = node;
          style.left = `${x + _size / 2}px`;
          style.top = `${y + _size / 2}px`;
        }
        return style
      }
    },
    methods: {
      toRoadmapPlanBuilder(slug) {
        this.$router.push({name: 'planBuilder', params: {slug}})
      },
      toConceptViewer(slug) {
        this.$router.push({name: 'conceptViewer', params: {slug}})
      }
    }
  }
</script>

<style scoped>
  a {
    text-decoration: none !important;
  }
</style>
